import { render, staticRenderFns } from "./LoginFailureModal.vue?vue&type=template&id=22472741&scoped=true"
import script from "./LoginFailureModal.vue?vue&type=script&lang=js"
export * from "./LoginFailureModal.vue?vue&type=script&lang=js"
import style0 from "./LoginFailureModal.vue?vue&type=style&index=0&id=22472741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22472741",
  null
  
)

export default component.exports